"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { classNames, responsiveClassNames } from "../../utilities/props.js";
import { useFormControl } from "../FormControl/index.js";
import Aligner from "../_private/Aligner/index.js";
import useElementId from "../../hooks/useElementId.js";
import s from "./TextArea.module.css";
const TextArea = (props) => {
    const { onChange, onFocus, onBlur, name, value, defaultValue, placeholder, size = "medium", variant = "outline", resize, className, attributes, } = props;
    const [autogrowValue, setAutogrowValue] = React.useState(value || defaultValue || "");
    const formControl = useFormControl();
    const id = useElementId(props.id);
    const inputId = formControl?.attributes?.id || props.inputAttributes?.id || id;
    const disabled = formControl?.disabled || props.disabled;
    const hasError = formControl?.hasError || props.hasError;
    const inputAttributes = { ...props.inputAttributes, ...formControl?.attributes };
    const rootClassName = classNames(s.root, size && responsiveClassNames(s, "--size", size), hasError && s["--status-error"], disabled && s["--disabled"], variant && s[`--variant-${variant}`], resize !== undefined && s[`--resize-${resize}`], className);
    const handleChange = (event) => {
        const nextValue = event.target.value;
        onChange?.({ name, value: nextValue, event });
        if (resize === "auto" && typeof value !== "string") {
            setAutogrowValue(nextValue);
        }
    };
    React.useEffect(() => {
        if (typeof value !== "string" || resize !== "auto")
            return;
        setAutogrowValue(value);
    }, [value, resize]);
    return (_jsx("div", { ...attributes, "data-rs-aligner-target": true, className: rootClassName, "data-rs-textarea-value": autogrowValue, children: _jsx("textarea", { rows: 3, ...inputAttributes, className: s.input, disabled: disabled, name: name, placeholder: placeholder, value: value, defaultValue: defaultValue, onChange: handleChange, onFocus: onFocus || inputAttributes?.onFocus, onBlur: onBlur || inputAttributes?.onBlur, id: inputId }) }));
};
TextArea.Aligner = Aligner;
TextArea.displayName = "TextArea";
export default TextArea;
